import crews from "csi/access/crews";
import ActionData from "csi/heading/ActionData";
import RefContainer from "csi/heading/RefContainer";
import declare from "dojo/_base/declare";

const PRODUCT_COMPLIANCE_ANALYSIS_ADMINISTRATOR = "Product Compliance Analysis Administrator";

const DefaultComplianceAnalysisCountriesRoleRenderer = declare(RefContainer, {
	_getRenderAction(): ActionData {
		const _userCanEdit = crews.isInRoles([PRODUCT_COMPLIANCE_ANALYSIS_ADMINISTRATOR]);
		if (!_userCanEdit) {
			return;
		}
		return this.inherited<ActionData>(arguments);
	},
});

export = DefaultComplianceAnalysisCountriesRoleRenderer;